'use client';
export default function IconArrow() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
            <path d="M10.5625 4.60417L6.22917 8.9375L1.89583 4.60416" stroke="black" strokeWidth="1.1375" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
